import { render, staticRenderFns } from "./TemplateTwoColPage.vue?vue&type=template&id=2efdb632&scoped=true"
import script from "./TemplateTwoColPage.vue?vue&type=script&lang=js"
export * from "./TemplateTwoColPage.vue?vue&type=script&lang=js"
import style0 from "./TemplateTwoColPage.vue?vue&type=style&index=0&id=2efdb632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efdb632",
  null
  
)

export default component.exports